import React, { Component } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Container from '@mui/material/Container';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { ADDITIONAL_DETAILS_CREATE_APPOINTMENT } from "../../../constants/insurance/options";
import { RuleEngine, getAllDC, getStateCityLocalityDC } from "../../../services/insurance/common";
import Geocoder from 'react-native-geocoding';
import Button from '@mui/material/Button';
import { CheckDuplicacy, axiosCallToCreateAppointment } from '../../../services/insurance/createAppointmentService';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'
import { USER } from '../../../constants/insurance/constant';
import { getCorporate } from '../../../services/insurance/esales';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

class CreateAppointment extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dialogModal : this.props && this.props.dialogModal ? true : false,
      dateTimeFirst: new Date(),
      dateTimeSecond: new Date(),
      stateId: '',
      selectedTags: '',
      cityId: '',
      locationId: '',
      packageIds: [],
      additionalDetailsTuples: ADDITIONAL_DETAILS_CREATE_APPOINTMENT.details,
      states: localStorage.getItem("states") && localStorage.getItem("states") !== undefined ? JSON.parse(localStorage.getItem("states")) : [],
      cities: [],
      diagnosticCenters: [],
      localities: [],
      packages: localStorage.getItem("packages") ? JSON.parse(localStorage.getItem("packages")) : [],
      selectVisitType: '',
      addtionalDetailsKey: '',
      addtionalDetailsValue: '',
      addtionalDetails: [],
      dcSelected: {
        id: '',
        entityName: ''
      },
      nameError: '',
      customerUniqueIdError: '',
      annualPremiumError: '',
      emailError: '',
      genderError: '',
      primaryMobileNumberError: '',
      alternateMobileNumberError: '',
      paidorSponsError: '',
      grouporIndividualError: '',
      sumAssuredError: '',
      packageError: '',
      visitTypeError: '',
      firstPrefTimeError: '',
      secPrefTimeError: '',
      selectStateError: '',
      selectCityError: '',
      selectLocalityError: '',
      selectDcError: '',
      customerName: this.props && this.props.esalesValue && this.props.esalesValue.name ? this.props.esalesValue.name :  '',
      clientDOB:"",
      showMessage:false,
      message:"",
      orderCreated:false,
      isEnabled: 0
    }
    this.initState = {
      dialogModal : this.props && this.props.dialogModal ? true : false,
      dateTimeFirst: new Date(),
      dateTimeSecond: new Date(),
      stateId: '',
      selectedTags: '',
      cityId: '',
      locationId: '',
      packageIds: [],
      additionalDetailsTuples: ADDITIONAL_DETAILS_CREATE_APPOINTMENT.details,
      states: localStorage.getItem("states") && localStorage.getItem("states") !== undefined ? JSON.parse(localStorage.getItem("states")) : [],
      cities: [],
      diagnosticCenters: [],
      localities: [],
      packages: localStorage.getItem("packages") ? JSON.parse(localStorage.getItem("packages")) : [],
      selectVisitType: '',
      addtionalDetailsKey: '',
      addtionalDetailsValue: '',
      addtionalDetails: [],
      dcSelected: {
        id: '',
        entityName: ''
      },
      nameError: '',
      customerUniqueIdError: '',
      annualPremiumError: '',
      emailError: '',
      genderError: '',
      primaryMobileNumberError: '',
      alternateMobileNumberError: '',
      paidorSponsError: '',
      grouporIndividualError: '',
      sumAssuredError: '',
      packageError: '',
      visitTypeError: '',
      firstPrefTimeError: '',
      secPrefTimeError: '',
      selectStateError: '',
      selectCityError: '',
      selectLocalityError: '',
      selectDcError: '',
      customerName: this.props && this.props.esalesValue && this.props.esalesValue.name ? this.props.esalesValue.name :  '',
      clientDOB:"",
      showMessage:false,
      message:"",
      orderCreated:false,
      isEnabled: 0
    }
  }

  componentDidMount() {
    if (!localStorage.getItem("packages")) {
      this.getPackages();
    }
    if (!(localStorage.getItem("states") && localStorage.getItem("states") !== undefined)) {
      this.getAllStates();
    }
  }


  getAllStates() {
    getStateCityLocalityDC('state').then(response => {
      this.setState({
        states: response.lookUpData
      }, () => {
        localStorage.setItem("states", JSON.stringify(response.lookUpData))
      });
    })
  }

  getCity(obj) {
    this.setState({
      stateId: obj.lookUpId,
      stateSelected: obj
    })
    getStateCityLocalityDC('city', obj.lookUpId, 2).then(response => {
      this.setState({
        cities: response.lookUpData
      });
    })
  }

  getLocality(obj) {
    this.setState({
      cityId: obj.lookUpId,
      citySelected: obj
    })
    getStateCityLocalityDC('location', obj.lookUpId).then(response => {
      this.setState({
        localities: response.lookUpData
      });
    })
  }

  getDCDetails(obj) {
    this.setState({
      dcSelected: obj
    })
  }

  getDC(obj) {
    this.setState({
      locationId: obj.lookUpId,
      locationSelected: obj
    })


    getAllDC(this.state.stateId, this.state.cityId, obj.lookUpId, this.state.packageIds).then(response => {
      this.setState({
        diagnosticCenters: response && response.providers
      });
      // && response.providers
    })

    // console.log("states >>", this.state)
  }

  setDateTimePickerFirst(value) {
    this.setState({
      dateTimeFirst: value
    })
  }

  setDateTimePickerSecond(value) {
    this.setState({
      dateTimeSecond: value
    })
  }

  setAddtionalDetailsKey(event) {
    this.setState({
      addtionalDetailsKey: event.target.value
    })
  }

  handleFieldChange(event) {
    event.preventDefault();
    const { name, value } = event.target;
    console.log("Event", event.target.id);

    //add switch case here

    this.setState({
      [name]: value
    }, () => {
      // console.log("this state >>", that.state)
      this.switchCase(name);
    });

  }

  switchCase = (name) => {
    switch (name) {
      case 'customerName':
        this.validateName();
        break;
      case 'email-address':
        this.validateEmail();
        break;
      case 'customer-unique-id':
        this.validateCustomerUniqueId();
        break;
      case 'primary-mobile-number':
        this.validatePrimaryMobileNumber();
        break;
      case 'annual-premium':
        this.validateAnnualPremium();
        break;
      case 'alternate-mobile-number':
        this.validateAlternateMobileNumber();
        break;
      case 'sum-assured':
        this.validateSumAssured();
        break;
      default:
        break;
    }
  }

  getLocation(place) {
    Geocoder.from(place)
      .then(json => {
        var location = json.results[0].geometry.location;
        // console.log("location", location);
        this.setState({
          location: location
        })
      })
      .catch(error => console.warn(error));
  }

  setAddtionalDetailsValue(event) {
    this.setState({
      addtionalDetailsValue: event.target.value
    })
  }

  getPackages() {
    const that = this;
    RuleEngine().then(data => {
      that.setState({
        packages: data.ruleEnginePackages
      }, () => {
        localStorage.setItem("packages", JSON.stringify(data.ruleEnginePackages))
      });
    })
  }

  addAdditionDetailsToRow() {
    let rows = this.state.addtionalDetails;
    let obj = {
      name: this.state.addtionalDetailsKey,
      value: this.state.addtionalDetailsValue
    }

    let index = -1;
    if (rows.length > 0) {
      index = rows.findIndex(function (elem) {
        return elem.name === obj.name
      });
    }

    if ((index === -1) && this.state.addtionalDetailsKey && this.state.addtionalDetailsValue) {
      rows.push(obj);
      this.setState({
        addtionalDetails: rows,
        addtionalDetailsKey: '',
        addtionalDetailsValue: ''
      })
    }
  }


  deleteAdditionDetailsToRow(elem, index) {
    const that = this;
    let rows = this.state.addtionalDetails;
    rows.splice(rows.findIndex(a => a.name === elem.name), 1)
    this.setState({
      addtionalDetails: rows
    }, () => {
      that.showAdditionalDetails();
    })
  }

  locationSearchChange = (value) => {
    this.setState({
      location: value
    });
    console.log("value", value)
  }

  checkPackages = (event, values) => {

    let ids = [];
    ids = values.map(elem => (elem.peR_Id)
    );
    console.log("IDs", ids);
    console.log("prodID", values);
    this.setState({
      selectedTags: values,
      packageIds: ids
    });
  }

  showAdditionalDetails() {
    return (
      <div>
        {this.state.addtionalDetails.length > 0 ?
          this.state.addtionalDetails.map((elem, index) => (
            <div className='flex space-between border border-solid border-gray-100 p- w-full mb-1' key={index}>
              <div className="w-47-per border-r-2 p-2"> {elem.name}</div>
              <div className="w-48-per border-l-2 p-2">{elem.value} </div>
              <div className="w-5-per m-auto">
                <button type="button" className="rounded-full h-10 w-10 bg-red-500 m-1 flex items-center justify-center" onClick={() => this.deleteAdditionDetailsToRow(elem, index)}>
                  <span className="font-extrabold text-2xl text-gray-100"> - </span>
                </button>
              </div>
            </div>
          )) : ''
        }
      </div>
    )
  }

  checkDuplicacy = (formData, localStorageData) => {
    console.log("Duplicate");
    CheckDuplicacy(formData, localStorageData);
  }

  order = (formData) => {
    const that = this;
    axiosCallToCreateAppointment(formData).then((response) => {
      if (response.isSuccess){
        that.setState({showMessage:true, orderCreated: true, message: `Appointment created successfully, Order Number: ${response.orderNumber}` })
      }else{
        that.setState({showMessage:true, orderCreated: false, message: `Unable to create appointment: ${response.errorMessage}` })
      }
    });
  }
  submitDetails = (event) => {
    if (!this.canBeSumitted()) {
      event.preventDefault();
      return;
    }
    event.preventDefault();
    let stateData = this.state;
    console.log("state >>", this.state);

    let formData = {};



    formData.actualAmount = 0;
    formData.amountAfterDiscount = 0;
    formData.contractId = 9782

    formData.createdByApp = "Medibuddy Plus";
    formData.employeeContactNo = stateData["primary-mobile-number"];
    formData.employeeEmail = stateData["email-address"];
    formData.employeeId = stateData["customer-unique-id"];
    formData.employeeName = stateData["customerName"];
    formData.entityId = getCorporate()?.id;
    formData.entityName = USER.user.entityName
    formData.gender = stateData.gender;
    formData.orderItems = [];
    formData.paymentFailureUrl = "www.mediassistindia.com";
    formData.paymentMode = "IndividualPaid";
    formData.paymentState = "Unpaid";
    formData.paymentSuccessUrl = "www.mahs.in";
    formData.requestAccessToken = JSON.parse(localStorage.getItem("access_token"));
    formData.additionals = {};

    console.log("FORMDATA", formData.requestAccessToken);
    console.log("LOCAL storage", localStorage.getItem("access_token"));

    formData.showPaid = false;
    formData.paid = true;


    stateData.packageIds.forEach(id => {
      let packageObj = {};
      packageObj.productId = id;
      formData.orderItems.push(packageObj);
    })

    let packageMap = new Map();

    let selectedPackages = stateData.packages.filter(row => {
      return stateData.packageIds.indexOf(row.peR_Id) >= 0 && packageMap.set(row.peR_Id, row);
    })

    console.log("selected Packages", selectedPackages);

    formData.orderItems.forEach(obj => {
      obj.MAID = formData.employeeId;
      obj.maid = formData.employeeId;
      obj.employeeId = formData.employeeId;
      obj.addressLine1 = stateData["address-line-1"];
      obj.addressLine2 = stateData["address-line-2"];
      obj.additionalDetails = stateData && stateData.addtionalDetails ? stateData.additionalDetails : [];
      console.log("Additional Details", obj);
      obj.amount = packageMap.get(obj.productId)["packagePrice"] + packageMap.get(obj.productId)["serviceTax"];
      obj.city = "";
      obj.contactNum = formData.employeeContactNo;
      obj.emailId = formData.employeeEmail;
      obj.firstName = formData.employeeName;
      obj.gender = formData.gender;
      obj.grade = "";
      obj.invoiceTo = "177310";
      obj.isPaid = stateData["Paid-Sponsored"] === "Paid";
      obj.isSponsored = stateData["Paid-Sponsored"] === "Sponsored";
      obj.preferredDC = [{}];
      obj.preferredDC[0].firstPrefTime = new Date(stateData.dateTimeFirst).toISOString();
      obj.preferredDC[0].secPrefTime = new Date(stateData.dateTimeSecond).toISOString();
     
      if (this.state.selectVisitType === "Home Visit") {
        obj.preferredDC[0].id = 407518;
        obj.preferredDC[0].name = "Schedule Home Visit";
        obj.visitType = "Home_Visit";
      } else {
        obj.preferredDC[0].id = stateData.dcSelected ? stateData.dcSelected.id : 0;
        obj.preferredDC[0].name = stateData.dcSelected ? stateData.dcSelected.entityName : "";
        obj.visitType = "Appointment";

        obj.preferredDC[0].ProviderCity = stateData.citySelected ? stateData.citySelected.lookUpValue : "";
        obj.preferredDC[0].ProviderLocation = stateData.locationSelected ? stateData.locationSelected.lookUpValue : "";
      }

      obj.relation = "Self";
      obj.productName = packageMap.get(obj.productId)["packageName"];
      obj.productType = packageMap.get(obj.productId)["contract"]["contractId"];
      obj.additionalProperties = {};
      obj.additionalProperties.clientDOB = stateData.clientDOB ? stateData.clientDOB : "";
      obj.additionalProperties.insurerRemark = stateData.remarks ? stateData.remarks : "";
      obj.additionalProperties.alternateMobile = stateData["alternate-mobile-number"] ? stateData["alternate-mobile-number"] : "";
      obj.additionalProperties.sumAssured = stateData["sum-assured"] ? stateData["sum-assured"] : "";
      obj.additionalProperties.paidSpons = stateData.paidorSponsorship;
      obj.additionalProperties.policyType = stateData.grouporIndividual;
      obj.additionalProperties.annualPremium = stateData["annual-premium"] ? stateData["annual-premium"] : "";
      obj.additionalProperties.id = null;
      obj.additionalProperties.DND = null;
      obj.additionalProperties.DNDCustomer = null;

      stateData.addtionalDetails.forEach(detail => {
        obj.additionalProperties[detail.name] = detail.value;
      })

      console.log("AdditionalDetails", obj.additionalDetails);
    })

    // this.checkDuplicacy(formData, localStorageData);
    this.order(formData);
  }

  validateName = () => {
    const customerName = this.state["customerName"];
    console.log("State >>", this.state);
    console.log("customer", customerName);
    this.setState({
      nameError: customerName && customerName.length > 3 ? null : "Name must be longer than 3 charecters"
    })
  }

  validateEmail = () => {
    const email = this.state["email-address"];
    let emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.setState({
      emailError: emailRegex.test(email) ? null : "Enter valid email address"
    }) // regex
  }

  validateCustomerUniqueId = () => {
    const customerUniqueId = this.state["customer-unique-id"];
    this.setState({
      // customerUniqueIdError: isNaN(customerUniqueId) ? "Customer Unique ID has to be a Number" : null
      customerUniqueIdError: customerUniqueId ? "" : "Unique ID cannot be blank"
    })
  } // add exception for e

  validateAnnualPremium = () => {
    console.log("Typeof", typeof this.state["customer-unique-id"]);
    this.setState({
      // annualPremiumError: isNaN(annualPremium) ? "Annual Premium has to be a Number" : null
    })
  }

  validateGender = () => {
    const gender = this.state["gender"];
    const avaliableGenders = ['Male', 'Female', 'Others'];
    this.setState({
      genderError: avaliableGenders.includes(gender) ? null : 'Enter gender'
    })
  }

  validatePrimaryMobileNumber = () => {
    const primaryMobileNumber = this.state["primary-mobile-number"];
    let indianPhoneNumberRegex = /^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[789]\d{9}$/;
    this.setState({
      primaryMobileNumberError: indianPhoneNumberRegex.test(primaryMobileNumber) ? null : "Enter correct phone number"
    }) // indian phone number regex
  }

  validateAlternateMobileNumber = () => {
    const alternateMobileNumber = this.state["alternate-mobile-number"];
    const indianPhoneNumberRegex = /^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[789]\d{9}$/;
    this.setState({
      alternateMobileNumberError: indianPhoneNumberRegex.test(alternateMobileNumber) ? null : "Enter correct phone number"
    })
  }

  validateSumAssured = () => {
    const sumAssured = this.state["sum-assured"];
    this.setState({
      sumAssuredError: isNaN(sumAssured) ? "Annual Premium has to be a Number" : null
    })
  }

  canBeSumitted = () => {
    const { nameError, emailError, primaryMobileNumberError, genderError } = this.state;
    return nameError == null && emailError == null && primaryMobileNumberError == null && genderError == null;
  }

  reset=()=>{
    this.setState(this.initState);
  }

  render() {
    return (
      <div className="mt-5">
        <Container className={this.state.dialogModal ? "bg-white" : "p-5 shadow-md bg-white"}>
          {
            this.state.dialogModal ? "" : 
              <div className="flex justify-around font-semibold text-gray-600 text-sm shadow-inner bg-create-appointment-heading p-1 text-center w-60 rounded mb-2">
               CREATE APPOINTMENT <div className="w-2 h-2 my-auto rounded bg-green-500"></div>
              </div>
          }
         
        <Box
          component="form"
          sx={{
            '& > :not(style)': { padding: '5px 0px' },
          }}
          onSubmit={(event) => this.submitDetails(event)}
          noValidate
          autoComplete="off"
        >
          <div className="flex w-full justify-between">
            <div className="w-49-per">
              <TextField
                className="w-full"
                id="customerName"
                name="customerName"
                label="Customer name"
                value={this.state.customerName}
                onChange={(event) => { this.handleFieldChange(event) }}
                onBlur={this.validateName}
                required
              />
              <div className="text-red-500 text-sm">
                {this.state.nameError}
              </div>
            </div>
            <div className="w-49-per">
              <TextField
                className="w-full"
                id="customer-unique-id"
                name="customer-unique-id"
                label="Customer unique id"
                // type="number"
                onChange={(event) => { this.handleFieldChange(event) }}
                onBlur={this.validateCustomerUniqueId}
                required
              // onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
              />
              <div className="text-red-500 text-sm">
                {this.state.customerUniqueIdError}
              </div>
            </div>
          </div>


          <div className="flex w-full justify-between">
            <div className="w-49-per">
              <TextField
                className="w-full"
                id="annual-premium"
                name="annual-premium"
                label="Annual Premium"
                onChange={(event) => { this.handleFieldChange(event) }}
                onBlur={this.validateAnnualPremium}
                type="number"
                onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
              />
              <div className="text-red-500 text-sm">
                {this.state.annualPremiumError}
              </div>
            </div>
            <div className="w-49-per">
              <TextField
                className="w-full"
                id="email-address"
                name="email-address"
                label="Email Address"
                onChange={(event) => { this.handleFieldChange(event) }}
                onBlur={this.validateEmail}
              />
              <div className="text-red-500 text-sm">
                {this.state.emailError}
              </div>
            </div>
          </div>

          <div className="flex w-full justify-between">
            <div className="w-49-per">
              <FormControl className="w-full">
                <InputLabel id="gender">Gender</InputLabel>
                <Select
                  labelId="gender"
                  name="gender"
                  id="gender"
                  value={this.state.gender ? this.state.gender : ''}
                  label="Gender"
                  onChange={(event) => { this.handleFieldChange(event) }}
                  onBlur={this.validateGender}
                  required
                >
                  <MenuItem value={'Male'}>Male</MenuItem>
                  <MenuItem value={'Female'}>Female</MenuItem>
                  <MenuItem value={'Others'}>Others</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className="w-49-per">
              <TextField
                className="w-full"
                id="primary-mobile-number"
                name="primary-mobile-number"
                label="Primary mobile number"
                onChange={(event) => { this.handleFieldChange(event) }}
                required
                onBlur={this.validatePrimaryMobileNumber}
              />
              <div className="ftext-red-500 text-sm">
                {this.state.primaryMobileNumberError}
              </div>
            </div>
          </div>


          <div className="flex w-full justify-between">
            <div className="w-49-per">
              <TextField
                className="w-full"
                id="alternate-mobile-number"
                name="alternate-mobile-number"
                label="Alternate mobile number"
                onChange={(event) => { this.handleFieldChange(event) }}
                onBlur={this.validateAlternateMobileNumber}
              />
              <div className="text-red-500 text-sm">
                {this.state.alternateMobileNumberError}
              </div>
            </div>
            <div className="w-49-per">
              <FormControl className="w-full">
                <InputLabel id="Paid-Sponsored">Paid / Sponsored</InputLabel>
                <Select
                  labelId="Paid-Sponsored"
                  id="paid-sponsored-select"
                  name="paidorSponsorship"
                  value={this.state.paidorSponsorship ? this.state.paidorSponsorship : ''}
                  label="Paid/Sponsored"
                  onChange={(event) => this.handleFieldChange(event)}
                >
                  <MenuItem value={'Paid'}>Paid</MenuItem>
                  <MenuItem value={'Sponsored'}>Sponsored</MenuItem>
                </Select>
              </FormControl>
            </div>
          </div>


          <div className="flex w-full justify-between">
            <div className="w-49-per">
              <FormControl className="w-full">
                <InputLabel id="Group-Individual">Group / Individual</InputLabel>
                <Select
                  labelId="Group-Individual"
                  id="group-individual-select"
                  name="grouporIndividual"
                  value={this.state.grouporIndividual ? this.state.grouporIndividual : ''}
                  label="Group/Individual"
                  onChange={(event) => this.handleFieldChange(event)}
                >
                  <MenuItem value={'Group'}>Group</MenuItem>
                  <MenuItem value={'Individual'}>Individual</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className="w-49-per">
              <TextField
                className="w-full"
                id="sum-assured"
                name="sum-assured"
                label="Sum assured"
                type="number"
                onChange={(event) => { this.handleFieldChange(event) }}
                onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                onBlur={this.validateSumAssured}
              />
              <div className="text-red-500 text-sm">
                {this.state.sumAssuredError}
              </div>
            </div>
          </div>


          <div className="flex w-full justify-between">
            <div className="w-49-per">
              <TextField
                className="w-full"
                id="remarks"
                name="remarks"
                label="Remarks"
                multiline
                maxRows={2}
                onChange={(event) => this.handleFieldChange(event)}
              />
            </div>
            <div className="w-49-per">
              <TextField
                className="w-full"
                id="dob-local"
                name="clientDOB"
                label="Date of birth"
                type="datetime-local"
                InputProps={{ inputProps: { max: new Date()  } }}
                defaultValue={this.state.clientDOB ? this.state.clientDOB : ''}
                onChange={(event) => this.handleFieldChange(event)}
                // onChange={() => this.setDateTimePickerFirst()}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
          </div>

          <div className="flex w-full justify-between">
            <div className="w-49-per">
              <Autocomplete
                className="w-full"
                multiple
                id="checkboxes-tags-demo"
                options={this.state.packages}
                disableCloseOnSelect
                onChange={this.checkPackages}
                getOptionLabel={(option) => option.packageName}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option.packageName}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField {...params} label="Select appropriate package" placeholder="Select appropriate package" />
                )}
              />
            </div>

            <div className="w-49-per">
              <FormControl className="w-full">
                <InputLabel id="Select-visit-type">Select visit type</InputLabel>
                <Select
                  labelId="Select-visit-type"
                  id="demo-simple-select"
                  name="selectVisitType"
                  value={this.state.selectVisitType ? this.state.selectVisitType : ''}
                  label="Select visit type"
                  onChange={(event) => this.handleFieldChange(event)}
                >
                  <MenuItem key={'Center Visit'} value={'Center Visit'}>Center Visit</MenuItem>
                  <MenuItem key={'Home Visit'} value={'Home Visit'}>Home Visit</MenuItem>
                </Select>
              </FormControl>
            </div>
          </div>

          <div className="pt-5 flex w-full justify-between">
            <div className="w-49-per">
              <TextField
                className="w-full"
                id="datetime-local"
                name="dateTimeFirst"
                label="First Preference"
                type="datetime-local"
                InputProps={{ inputProps: { min: new Date() } }}
                defaultValue={this.state.dateTimeFirst ? this.state.dateTimeFirst : ''}
                onChange={(event) => this.handleFieldChange(event)}
                // onChange={() => this.setDateTimePickerFirst()}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
            <div className="w-49-per">
              <TextField
                className="w-full"
                id="datetime-local"
                name="dateTimeSecond"
                label="Second Preference"
                type="datetime-local"
                InputProps={{ inputProps: { min: new Date() } }}
                defaultValue={this.state.dateTimeSecond ? this.state.dateTimeSecond : ''}
                onChange={(event) => this.handleFieldChange(event)}
                // onChange={() => this.setDateTimePickerSecond()}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
          </div>


          {/* <div className="pt-5 flex w-full justify-between">
            <div className="w-48-per">
              <button className="w-full bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded">
                Advance DC
              </button>
            </div>
            <div className="w-48-per">
              <button className="w-full bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded">
                Manual DC
              </button>
            </div>
          </div> */}

          {
            this.state.selectVisitType ? this.state.selectVisitType === 'Home Visit' ?
              <div className="pt-5 flex w-full justify-between">
                <div className="w-49-per">
                  <TextField
                    className="w-full"
                    id="address-line-1"
                    name="address-line-1"
                    label="Address Line 1"
                    onChange={(event) => this.handleFieldChange(event)}
                  />
                </div>
                <div className="w-49-per">
                  <TextField
                    className="w-full"
                    id="address-line-2"
                    name="address-line-2"
                    label="Address Line 2"
                    onChange={(event) => this.handleFieldChange(event)}
                  />
                </div>
              </div>
              :
              this.state.selectVisitType === 'Center Visit' ?
                <div className="pt-5 flex w-full justify-between flex-wrap">
                  <div className="flex justify-between w-49-per">
                    <div className="w-49-per">
                      <FormControl className="w-full">
                        <InputLabel id="state">Select State</InputLabel>
                        <Select
                          labelId="state"
                          id="demo-simple-select"
                          label="Select State"
                        >
                          {
                            this.state.states ? this.state.states.map(elem => (
                              <MenuItem value={elem.lookUpId} onClick={() => this.getCity(elem)}>{elem.lookUpValue}</MenuItem>
                            )) : ''
                          }

                        </Select>
                      </FormControl>
                    </div>
                    <div className="w-49-per">
                      <FormControl className="w-full">
                        <InputLabel id="city">Select City</InputLabel>
                        <Select
                          labelId="city"
                          id="demo-simple-select"
                          label="Select City"
                        >
                          {
                            this.state.cities ? this.state.cities.map(elem => (
                              <MenuItem value={elem.lookUpId} onClick={() => this.getLocality(elem)}>{elem.lookUpValue}</MenuItem>
                            )) : ''
                          }
                        </Select>
                      </FormControl>
                    </div>
                  </div>

                  <div className="flex justify-between w-49-per">
                    <div className="w-49-per">
                      <FormControl className="w-full">
                        <InputLabel id="Locality">Select Locality</InputLabel>
                        <Select
                          labelId="Locality"
                          id="demo-simple-select"
                          label="Select Locality"
                          name="localityId"
                        >
                          {
                            this.state.localities ? this.state.localities.map(elem => (
                              <MenuItem value={elem.lookUpId} onClick={() => this.getDC(elem)}>{elem.lookUpValue}</MenuItem>
                            )) : ''
                          }
                        </Select>
                      </FormControl>
                    </div>
                    <div className="w-49-per">
                      <FormControl className="w-full" >
                        <InputLabel id="dc">Select DC</InputLabel>
                        <Select
                          labelId="dc"
                          id="demo-simple-select"
                          label="Select DC"
                          name="dcId"
                          value={this.state.dcId || ''}
                          onChange={(event) => this.handleFieldChange(event)}
                        >
                          {
                            this.state.diagnosticCenters.length > 0 ? this.state.diagnosticCenters.map(elem => (
                              <MenuItem value={elem.id} onClick={() => this.getDCDetails(elem)}>{elem.entityName}</MenuItem>
                            )) : ''
                          }
                        </Select>
                      </FormControl>
                    </div>
                  </div>

                </div>
                : '' : ''
          }


          {/* <div className="pt-5 flex w-full justify-between">
            <div className="w-49-per">
              <TextField
                className="w-full"
                id="radius"
                name="radius"
                label="Select Radius"
                onChange={(event) => this.handleFieldChange(event)}
              />
            </div>

            <div className="w-49-per location-search-div">
              <LocationSearch onLocationSearch={this.locationSearchChange}/>
            </div>
          </div> */}




          <div className="w-full text-center pt-5 pb-5">
            <span className="font-extrabold text-lg">ADD ADDITIONAL DETAILS</span>
          </div>

          <div className="flex w-full justify-between">
            <FormControl className="w-46-per">
              <InputLabel id="additional-detail-key">Select Addition Details</InputLabel>
              <Select
                labelId="additional-detail-key"
                id="additional-detail-key"
                value={this.state.addtionalDetailsKey || ''}
                label="Select Addition Details"
                onChange={(event) => this.setAddtionalDetailsKey(event)}
              >
                {
                  this.state.additionalDetailsTuples.map(elem => (
                    <MenuItem key={elem} value={elem}>{elem}</MenuItem>
                  ))
                }
              </Select>
            </FormControl>

            <TextField
              className="w-46-per"
              id="add-value-additional-details"
              label="Add Value"
              value={this.state.addtionalDetailsValue || ''}
              onChange={(event) => this.setAddtionalDetailsValue(event)}
            />
            <div className="w-5-per">
              <button type="button" className="rounded-full h-12 w-12 bg-nav-bar-header m-1 flex items-center justify-center" onClick={() => this.addAdditionDetailsToRow()}>
                <span className="font-extrabold text-2xl text-gray-100"> + </span>
              </button>
            </div>
          </div>

          {this.showAdditionalDetails()}

          {/* <div className="pt-10">
          <GoogleMaps location={this.state.location}></GoogleMaps>
          </div> */}

          <div className='flex justify-center mt-10'>
            <Button type="submit" variant="contained" size="large" onClick={this.submitDetails} disabled={!this.canBeSumitted()}>
              <span className="p-1">
                SUBMIT APPOINTMENT
              </span>
            </Button>
          </div>


        </Box>
      </Container>

      <Dialog open={this.state.showMessage} onClose={()=>{this.setState({showMessage:false})}}>
        <DialogTitle>
          {
            this.state.orderCreated ? "Order Created" : "Order Creation Failed"
          }
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {this.state.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={()=>{this.state.orderCreated ? this.reset() : this.setState({showMessage:false})}}
            color="primary"
          >
            {
              this.state.orderCreated ? "Create Another" : "Retry"
            }
          </Button>
          <Button
            onClick={()=>{this.props.history.push("/"+localStorage.getItem("roleName")+"/appointments")}}
            color="primary"
          >
            Appointments
          </Button>
        </DialogActions>
      </Dialog>

      </div>
     
    );
  }
}

export default CreateAppointment;